import React, { memo, FC } from "react";
import Typography from "@mui/material/Typography";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import PleaseNote from "../PleaseNote";
import { Image } from "cloudinary-react";
import { sillColorAlum, sillColorBifoldAlum } from "./defaults";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useSillAlumSelector from "./useSillAlumSelector";
import { addScrollElements } from "../AccordionWrapper/AccordianWrapper";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

const ColLayoutSpacing = styled("div")(({ theme }) => ({
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
}));

const ColLayoutLeftDivider = styled("div")(({ theme }) => ({
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
  borderLeft: `2px solid ${theme.palette.divider}`,
}));

const AlumSillAccordian: FC = () => {
  const {
    sillOptions,
    handleClick,
    swingDirection,
    sillStyle,
    isBifold,
    handleClickColor,
    sillColor,
  } = useSillAlumSelector();
  const { readOnly } = useIsReadOnlyContextProviderContext();

  return (
    <>
      {addScrollElements(["Sill Finish", "Sill Dam Finish", "Sill Type"])}

      <ReusableAccordian
        accordionName="sill"
        heading="Sill Choice"
        secondaryHeading="Select sill choice"
        colOrRow="col"
      >
        {isBifold ? (
          <PleaseNote notes="Low Profile, embedded, and ramp sills are appropriate for extremely low-exposure environments only; no warranty for water penetration, wind penetration, or airborne particles with this option." />
        ) : (
          <PleaseNote notes="ADA Ultra Guide are appropriate for extremely low-exposure environments only; no warranty for water penetration, wind Penetration, or airborne particles with this option" />
        )}

        <ColLayout>
          <RowLayout>
            <ColLayoutSpacing>
              <Typography style={{ margin: "auto" }} variant="subtitle1">
                Sill Types
                <span style={{ color: "red", fontSize: 20 }}>*</span>
              </Typography>
              <RowLayout>
                {sillOptions.map((state) => (
                  <div
                    key={state.id}
                    onClick={() =>
                      state.disabled || readOnly ? null : handleClick(state.label)
                    }
                  >
                    <Choices
                      label={state.label}
                      variant={
                        state.label === sillStyle ? "filled" : "outlined"
                      }
                      checkMark={state.label === sillStyle ? true : false}
                      disabled={state.disabled || readOnly}
                    />
                  </div>
                ))}
              </RowLayout>
            </ColLayoutSpacing>

            <SillColor
              isBifold={isBifold}
              sillColor={sillColor || ""}
              handleClickColor={handleClickColor}
            />
          </RowLayout>

          {sillStyle && isBifold ? (
            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={`Sills/bifolds/Aluminum/${sillStyle.replaceAll(
                " ",
                "_",
              )}`}
            />
          ) : sillStyle && swingDirection ? (
            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={`Sills/swings/Aluminum/${
                sillStyle === "Flat" ? "flat" : swingDirection?.toLowerCase()
              }`}
            />
          ) : null}
        </ColLayout>
      </ReusableAccordian>
    </>
  );
};

interface SillColorProps {
  isBifold: boolean;
  handleClickColor: (label: string) => void;
  sillColor: string;
}

const SillColor: FC<SillColorProps> = ({
  isBifold,
  handleClickColor,
  sillColor,
}) => {
  const { readOnly } = useIsReadOnlyContextProviderContext();
  
  return (
    <ColLayoutLeftDivider>
      <Typography style={{ margin: "auto" }} variant="subtitle1">
        Sill Colors
        <span style={{ color: "red", fontSize: 20 }}>*</span>
      </Typography>
      <RowLayout>
        {isBifold ? (
          sillColorBifoldAlum.map((itm) => (
            <div key={itm.id} onClick={() => readOnly ? null : handleClickColor(itm.label)}>
              <Choices
                label={itm.label}
                variant={sillColor === itm.label ? "filled" : "outlined"}
                checkMark={sillColor === itm.label}
                disabled={readOnly}
              />
            </div>
          ))
        ) : (
          <Choices
            label={sillColorAlum.label}
            variant={"filled"}
            checkMark={true}
            disabled={true}
          />
        )}
      </RowLayout>
    </ColLayoutLeftDivider>
  );
};

export default memo(AlumSillAccordian);
